/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createClone } from '../../factoriesAny.js';
export var cloneDependencies = {
  typedDependencies,
  createClone
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesClone.generated.js
// module id = oC+n
// module chunks = 3